"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcelControllerApi = exports.ExcelControllerApiFactory = exports.ExcelControllerApiFp = exports.ExcelControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ExcelControllerApi - axios parameter creator
 * @export
 */
const ExcelControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsEventGet: (searchField, searchString, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/excels/Event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {AttendanceStatus} [attendanceStatusFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsEventUserGet: (searchField, searchString, attendanceStatusFilter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/excels/EventUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (attendanceStatusFilter !== undefined) {
                localVarQueryParameter['attendanceStatusFilter'] = attendanceStatusFilter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsUserGet: (searchField, searchString, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/excels/User`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ExcelControllerApiAxiosParamCreator = ExcelControllerApiAxiosParamCreator;
/**
 * ExcelControllerApi - functional programming interface
 * @export
 */
const ExcelControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ExcelControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsEventGet(searchField, searchString, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiExcelsEventGet(searchField, searchString, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {AttendanceStatus} [attendanceStatusFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsEventUserGet(searchField, searchString, attendanceStatusFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiExcelsEventUserGet(searchField, searchString, attendanceStatusFilter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsUserGet(searchField, searchString, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiExcelsUserGet(searchField, searchString, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ExcelControllerApiFp = ExcelControllerApiFp;
/**
 * ExcelControllerApi - factory interface
 * @export
 */
const ExcelControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ExcelControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsEventGet(searchField, searchString, options) {
            return localVarFp.apiExcelsEventGet(searchField, searchString, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {AttendanceStatus} [attendanceStatusFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsEventUserGet(searchField, searchString, attendanceStatusFilter, options) {
            return localVarFp.apiExcelsEventUserGet(searchField, searchString, attendanceStatusFilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExcelsUserGet(searchField, searchString, options) {
            return localVarFp.apiExcelsUserGet(searchField, searchString, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ExcelControllerApiFactory = ExcelControllerApiFactory;
/**
 * ExcelControllerApi - object-oriented interface
 * @export
 * @class ExcelControllerApi
 * @extends {BaseAPI}
 */
class ExcelControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExcelControllerApi
     */
    apiExcelsEventGet(searchField, searchString, options) {
        return (0, exports.ExcelControllerApiFp)(this.configuration).apiExcelsEventGet(searchField, searchString, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {AttendanceStatus} [attendanceStatusFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExcelControllerApi
     */
    apiExcelsEventUserGet(searchField, searchString, attendanceStatusFilter, options) {
        return (0, exports.ExcelControllerApiFp)(this.configuration).apiExcelsEventUserGet(searchField, searchString, attendanceStatusFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExcelControllerApi
     */
    apiExcelsUserGet(searchField, searchString, options) {
        return (0, exports.ExcelControllerApiFp)(this.configuration).apiExcelsUserGet(searchField, searchString, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ExcelControllerApi = ExcelControllerApi;
